import React, {useState, useRef} from "react";
import {
  useNavigate,
  Link
} from 'react-router-dom';
import PropTypes from 'prop-types';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';



import HeaderPC from './HeaderPC';
import HeaderMobile from './HeaderMobile';
import HeaderTablet from './HeaderTablet';

import MenuModalPC from './MenuModalPC';
import MenuModalMobile from './MenuModalMobile';



const viewportHeight = window.innerHeight;

export default function Header(props) {

   const [bodyPos, setBodyPos] = useState(0);

   const headerPCRef = useRef(null);



   const handleClosePopMenu = () => {
     document.getElementById("myNav").style.display = "none";
     document.body.style.overflow = 'auto';
     document.body.style.position = 'relative';
    // window.scrollTo(0, bodyPos);

     if (headerPCRef.current) {
        headerPCRef.current.closeMenu();
     }



   }

    const handleMenuClick = (open) => {

        //alert(open)

          if (open)
         {
             var _bodyPos  = window.pageYOffset || document.documentElement.scrollTop;
             setBodyPos(_bodyPos);
             document.getElementById("myNav").style.display = "block";
            // document.body.style.overflow = 'hidden';
            // document.body.style.position = 'fixed';
         }
         else
         {
             document.getElementById("myNav").style.display = "none";
             document.body.style.overflow = 'auto';
             document.body.style.position = 'relative';
          //   window.scrollTo(0, bodyPos);
         }
    }


    const handleMenuClickMobile = (open) => {

        //alert(open)

          if (open)
         {
             var _bodyPos  = window.pageYOffset || document.documentElement.scrollTop;
             setBodyPos(_bodyPos);
             document.getElementById("myNav").style.display = "block";
             document.body.style.overflow = 'hidden';
             document.body.style.position = 'fixed';
         }
         else
         {
             document.getElementById("myNav").style.display = "none";
             document.body.style.overflow = 'auto';
             document.body.style.position = 'relative';
             window.scrollTo(0, bodyPos);
         }
    }


    const handleSearchChange = (query, objects) => {
       props.handleSearchChange(query, objects);
    }


    const handleSearchView = (view) => {
      props.handleSearchView(view);
    }



    return (

        <div>

              {!isMobileOnly && !isTablet &&
                <BrowserView>
                  <MenuModalPC {...props} handleClosePopMenu={handleClosePopMenu}/>
                  <HeaderPC ref={headerPCRef} {...props} handleMenuClick={handleMenuClick} handleSearchChange={handleSearchChange}/>
               </BrowserView>
             }

              {isMobileOnly &&
        			  <MobileView>
                   <MenuModalMobile {...props}/>
        	         <HeaderMobile {...props} handleMenuClick={handleMenuClickMobile} handleSearchChange={handleSearchChange} handleSearchView={handleSearchView}/>
        			 </MobileView>
        			}

        			{isTablet &&
        			  <TabletView>
                   <MenuModalPC {...props} handleClosePopMenu={handleClosePopMenu}/>
        			     <HeaderTablet ref={headerPCRef} {...props} handleMenuClick={handleMenuClick} handleSearchChange={handleSearchChange}/>
        			  </TabletView>
        			}

        </div>

    );




}


Header.propTypes = {

};
